// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3867c6cc","498":"61594db0","657":"35b03425","739":"2dc857fa","787":"235e9fed"}[chunkId] + ".chunk.js";
};